/* ==========================================================================
   Next10 — rodízio da faixa de vantagens ("VantagensFooter")
   Par do assets/n10-vantagens.css, usado por sections/next10-benefits.liquid.

   Comportamento copiado do site antigo (www.next10.com.br):
     if (window.matchMedia("(max-width: 767px)").matches) {
       document.querySelectorAll('.container-vantagens').forEach(function (e) {
         var vantagens = e.querySelectorAll('.vantagem'), i = 0;
         vantagens[0].classList.add('active');
         setInterval(function () { ...remove 'active', i = (i+1) % n, add 'active' }, 3000);
       });
     }
   Ou seja: abaixo de 768px mostra um item por vez trocando a cada 3s, sem
   dots e sem animação. De 768px para cima a faixa fica estática.

   Cuidados:
   - não roda com prefers-reduced-motion: reduce (o CSS empilha tudo)
   - aguenta a seção aparecer mais de uma vez na mesma página
   - o script pode ser incluído duas vezes: a segunda execução sai na hora
   - reage a resize, a troca de preferência de movimento e ao editor de tema
   - pausa quando a aba fica em segundo plano (não gasta CPU à toa)
   ========================================================================== */

(function () {
  'use strict';

  if (window.n10VbarReady) return;
  window.n10VbarReady = true;

  var INTERVAL = 3000; // mesmo tempo do site antigo
  var SWIPE_THRESHOLD = 44;
  var ITEM = 'n10-vbar__item';
  var mqMobile = window.matchMedia('(max-width: 767px)');
  var mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var rotators = [];

  function Rotator(list) {
    var self = this;

    this.list = list;
    this.items = [];
    this.index = 0;
    this.timer = null;
    this.active = false;
    this.touchStartX = null;
    this.touchStartY = null;

    for (var i = 0; i < list.children.length; i++) {
      if (list.children[i].classList.contains(ITEM)) {
        this.items.push(list.children[i]);
      }
    }

    this.show = function (index) {
      if (!self.items.length) return;
      self.items[self.index].classList.remove('is-active');
      self.index = (index + self.items.length) % self.items.length;
      self.items[self.index].classList.add('is-active');
    };

    this.next = function () {
      self.show(self.index + 1);
    };

    this.onTouchStart = function (event) {
      if (!self.active || event.touches.length !== 1) return;
      self.touchStartX = event.touches[0].clientX;
      self.touchStartY = event.touches[0].clientY;
      self.pause();
    };

    this.onTouchEnd = function (event) {
      if (self.touchStartX === null || !event.changedTouches.length) return;

      var deltaX = event.changedTouches[0].clientX - self.touchStartX;
      var deltaY = event.changedTouches[0].clientY - self.touchStartY;
      var isHorizontalSwipe = Math.abs(deltaX) >= SWIPE_THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY);

      if (isHorizontalSwipe) self.show(self.index + (deltaX < 0 ? 1 : -1));

      self.touchStartX = null;
      self.touchStartY = null;
      if (!document.hidden) self.play();
    };

    this.onTouchCancel = function () {
      self.touchStartX = null;
      self.touchStartY = null;
      if (!document.hidden) self.play();
    };

    this.list.addEventListener('touchstart', this.onTouchStart, { passive: true });
    this.list.addEventListener('touchend', this.onTouchEnd, { passive: true });
    this.list.addEventListener('touchcancel', this.onTouchCancel, { passive: true });
  }

  Rotator.prototype.destroy = function () {
    this.disable();
    this.list.removeEventListener('touchstart', this.onTouchStart);
    this.list.removeEventListener('touchend', this.onTouchEnd);
    this.list.removeEventListener('touchcancel', this.onTouchCancel);
  };

  Rotator.prototype.enable = function () {
    if (this.active || this.items.length < 2) return;
    this.active = true;
    this.index = 0;
    for (var i = 0; i < this.items.length; i++) {
      this.items[i].classList.toggle('is-active', i === 0);
    }
    // a classe no container é o sinal para o CSS assumir o modo rodízio
    this.list.classList.add('is-rotating');
    this.play();
  };

  Rotator.prototype.disable = function () {
    this.pause();
    if (!this.active) return;
    this.active = false;
    this.list.classList.remove('is-rotating');
    for (var i = 0; i < this.items.length; i++) {
      this.items[i].classList.remove('is-active');
    }
  };

  Rotator.prototype.play = function () {
    if (!this.active || this.timer) return;
    this.timer = window.setInterval(this.next, INTERVAL);
  };

  Rotator.prototype.pause = function () {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  };

  function sync() {
    var shouldRotate = mqMobile.matches && !mqReduced.matches;
    for (var i = 0; i < rotators.length; i++) {
      if (shouldRotate) {
        rotators[i].enable();
      } else {
        rotators[i].disable();
      }
    }
  }

  function collect() {
    for (var i = 0; i < rotators.length; i++) rotators[i].destroy();
    rotators = [];

    var lists = document.querySelectorAll('[data-n10-vbar]');
    for (var j = 0; j < lists.length; j++) rotators.push(new Rotator(lists[j]));

    sync();
  }

  function onVisibilityChange() {
    for (var i = 0; i < rotators.length; i++) {
      if (document.hidden) {
        rotators[i].pause();
      } else {
        rotators[i].play();
      }
    }
  }

  function listen(mq, handler) {
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', handler);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(handler); // Safari < 14
    }
  }

  listen(mqMobile, sync);
  listen(mqReduced, sync);
  document.addEventListener('visibilitychange', onVisibilityChange);
  document.addEventListener('shopify:section:load', collect);
  document.addEventListener('shopify:section:unload', collect);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collect);
  } else {
    collect();
  }
})();
